import { useEffect, useState } from "react";
import Page from "../../finwell/pages/Page";
import { useDispatch, useSelector } from "react-redux";
import {
  changeDueDateAssignUser,
  changeDueDateAssignUserResClear,
  getAssignUsersList,
  getAssignUsersListResClear,
  getTeamListReq,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import _, { template } from "lodash";
import Loader from "../../components/Loader/Loader";
import { Tab, Tabs } from "react-bootstrap";
import BackButton from "../../components/Layouts/BackButton";
import { useNavigate } from "react-router-dom";
import {
  getCoachingNotesListReq,
  getDeleteTeam,
  getDeleteTeamResponseClear,
  getMyTeamListReq,
  getMyTeamListReqResponseClear,
  impersonateUser,
} from "../../redux/user/actions";
import { useTranslation } from "react-i18next";
import CreateteamOptions from "../../components/AssignModal/CreateteamOptions";
import Modal from "react-bootstrap/Modal";
import ChooseTeammateForTeam from "../../components/AssignModal/ChooseTeammateForTeam";
import ChoosePeople from "../../components/AssignModal/ChoosePeople";
import ChooseFromCompletedCourse from "../../components/AssignModal/ChooseFromCompletedCourse";
import CreateTeam from "../../components/AssignModal/CreateTeam";
import NotFoundComponent from "../../components/NewDesign/NotFound/NotFoundComponent";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import ConfirmModal from "../../components/modal/ConfirmModal";
import GroupWorksopTrainerList from "../GroupWorksopTrainerList";
import TeamMembersModal from "./TeamMembersModal";
const MyTeamListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const { t } = useTranslation();
  const isMobile = params.get("isMobile");

  const [titleHeading, setTitleHeading] = useState("");
  const [isByNameTeam, setIsByNameTeam] = useState(false);
  const [show, setShow] = useState(false);
  const [filterReq, setFilterReq] = useState([]);
  const [key, setKey] = useState("myTeamsList");
  const [apiCall, setAPICall] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsgDelete, setShowModalMsgDelete] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isConfirm, setIsConfirm] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [isDeleteApiCalled, setIsDeleteApiCalled] = useState(false);
  const [teamsApiCalled, setTeamsApiCalled] = useState(false);

  const authBroker = useSelector((state) => state.auth.authBroker);
  const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([]);
  const [selectedTeamMatesListForTeam, setSelectedTeamMatesListForTeam] =
    useState([]);
  const [selectedOfficeList, setSelectedOfficeList] = useState([]);
  const [selectedCompletedCourseList, setSelectedCompletedCourseList] =
    useState([]);
  const [filteredFromCoursesOffices, setFilteredFromCoursesOffices] = useState(
    []
  );
  const [selectedTeamList, setSelectedTeamsList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);

  const myTeamsListRes = useSelector((state) => state.user.myTeamsListRes);
  const impersonateRes = useSelector((state) => state.user.impersonateUserData);

  const currentView = useSelector((state) => state.assignCourse.current_view);
  const [isLoading, setIsLoading] = useState(false);
  const [myTeamsList, setMyTeamsList] = useState([]);
  const [myTeamsListFilter, setMyTeamsListFilter] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedSort, setSelectedSort] = useState("");
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const teamsListRes = useSelector((state) => state.assignCourse.teamsList);
  const deleteTeamRes = useSelector((state) => state.user.deleteTeamRes);

  const getDefaultTeams = () => {
    setTeamsApiCalled(true);
    setIsLoading(true);
    dispatch(
      getTeamListReq({
        module: "getDefaultTeamsList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  useEffect(() => {
    if (apiCall) {
      getDefaultTeams();
    }
  }, [apiCall]);

  useEffect(() => {
    getMyTeamsList();
  }, [activeLanguage]);

  useEffect(() => {
    if (!_.isEmpty(teamsListRes) && teamsApiCalled) {
      setIsLoading(false);
      if (teamsListRes?.status === "success") {
        let list = teamsListRes?.payload?.payload;
        list.sort((a, b) => b.created_dt.localeCompare(a.created_dt));
        setTeamsList(list);
        console.log("--", teamsListRes?.payload?.payload.length);
        // if (teamsListRes?.payload?.payload.length === 0) {
        //   setisLoaded(true);
        // }
      } else {
        setTeamsList([]);
        // setisLoaded(true);
      }
    } else {
      setTeamsList([]);
    }
  }, [teamsListRes]);

  useEffect(() => {
    console.log("myTeamsListRes: ", myTeamsListRes);
    if (!_.isEmpty(myTeamsListRes)) {
      setIsLoading(false);
      window.scrollTo(0, 0);
      if (myTeamsListRes?.status === "success") {
        setMyTeamsList(myTeamsListRes?.payload?.payload);
        setMyTeamsListFilter(myTeamsListRes?.payload?.payload);
        setSelectedSort("name");
        dispatch(getMyTeamListReqResponseClear());
      } else {
        setMyTeamsList([]);
        setMyTeamsListFilter([]);
      }
    }
  }, [myTeamsListRes]);

  //get leader board
  const getMyTeamsList = () => {
    setIsLoading(true);
    dispatch(
      getMyTeamListReq({
        module: "myTeamListReq",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  const callDeleteTeamAPI = (id) => {
    setIsDeleteApiCalled(true);
    setIsLoading(true);
    dispatch(
      getDeleteTeam({
        // URL: `${CONFIG.API_URL_BROKER_ADMIN}/${API_LIST.API_ROUTES_REAL_BROKER.DELETE_TEAM}`,
        // method: "DELETE",
        // payload: {
        //   token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //   team_id: id,
        // },
        module: "deleteTeamFromMyTeams",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          team_id: id,
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(deleteTeamRes) && isDeleteApiCalled) {
      if (deleteTeamRes?.status === "success") {
        console.log("data--", deleteTeamRes);
        setShowModalMsg(t("Team deleted successfully."));
        setConfirmModal(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setShowModalMsg(
          t("Failed to delete team, please try again after sometime.")
        );
        setConfirmModal(true);
      }
    }
  }, [deleteTeamRes]);

  useEffect(() => {
    let timerId = null;
    if (_.isEmpty(searchValue)) {
      //   setIsLoading(true);
      setMyTeamsList(myTeamsListFilter);
      //   getCoachNotesDataReq();
    } else {
      timerId = setTimeout(() => {
        // getCoachNotesDataReq();
        let tempList = [];
        for (let i = 0; i < myTeamsListFilter.length; i++) {
          const element = myTeamsListFilter[i];
          let name = element.first_name + " " + element.last_name;
          if (
            name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
            element.email?.toLowerCase().includes(searchValue?.toLowerCase())
          ) {
            tempList.push(element);
          }
        }
        setMyTeamsList(tempList);
      }, 700);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [searchValue]);

  useEffect(() => {
    console.log("selectedSort: ", selectedSort, myTeamsList);
    if (!_.isEmpty(selectedSort) && !_.isEmpty(myTeamsList)) {
      let tempList = [];
      tempList = _.cloneDeep(myTeamsList);
      if (selectedSort === "name") {
        tempList.sort((a, b) => {
          const nameA =
            a.first_name.toUpperCase() + " " + a.last_name?.toUpperCase(); // ignore upper and lowercase
          const nameB =
            b.first_name.toUpperCase() + " " + b.last_name?.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "nameRev") {
        tempList.sort((a, b) => {
          const nameA =
            a.first_name.toUpperCase() + " " + a.last_name?.toUpperCase();
          const nameB =
            b.first_name.toUpperCase() + " " + b.last_name?.toUpperCase();
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "email") {
        tempList.sort((a, b) => {
          const nameA = a.email.toUpperCase(); // ignore upper and lowercase
          const nameB = b.email.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "emailRev") {
        tempList.sort((a, b) => {
          const nameA = a.email.toUpperCase(); // ignore upper and lowercase
          const nameB = b.email.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "role") {
        tempList.sort((a, b) => {
          const nameA = a.Role.toUpperCase(); // ignore upper and lowercase
          const nameB = b.Role.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "roleRev") {
        tempList.sort((a, b) => {
          const nameA = a.Role.toUpperCase(); // ignore upper and lowercase
          const nameB = b.Role.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } else if (selectedSort === "office") {
        tempList.sort((a, b) => {
          const nameA = a.office_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.office_name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } else if (selectedSort === "officeRev") {
        tempList.sort((a, b) => {
          const nameA = a.office_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.office_name.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      setMyTeamsList(tempList);
    }
  }, [selectedSort]);

  const callImpersonateAPI = (item) => {
    setIsLoading(true);
    dispatch(
      impersonateUser({
        module: "impersonate-user",
        postData: {
          user_id: item?.id,
        },
      })
    );
  };

  // useEffect(() => {
  //   if (!_.isEmpty(impersonateRes)) {
  //     console.log("check--",impersonateRes)
  //     if (impersonateRes?.status === "success") {

  //     } else {

  //     }
  //   }
  // }, [impersonateRes]);

  const handleViewTeamMembersClick = (team_members) => {
    setSelectedTeamMembers(team_members);
    setShowModal(true);
  };

  const renderTableReport = () => {
    return (
      <>
        <div className="row my-team-table">
          <div className="col-lg-12 col-md-12">
            <div className="course-info-table">
              {myTeamsList.length > 0 ? (
                <table className="table mb-0 office_list table-striped">
                  <thead>
                    <tr>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "name" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "name") {
                            setSelectedSort("nameRev");
                          } else setSelectedSort("name");
                        }}
                        style={{ minWidth: "300px" }}
                      >
                        {t("Name")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "email" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "email") {
                            setSelectedSort("emailRev");
                          } else setSelectedSort("email");
                        }}
                        style={{ minWidth: "300px" }}
                      >
                        {t("Email")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "role" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "role") {
                            setSelectedSort("roleRev");
                          } else setSelectedSort("role");
                        }}
                        style={{ width: "auto" }}
                      >
                        {t("Role")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "office" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "office") {
                            setSelectedSort("officeRev");
                          } else setSelectedSort("office");
                        }}
                        style={{ width: "auto" }}
                      >
                        {t("Office")}
                      </th>
                      {/* <th
                          className={`cursor-pointer`} 
                          style={{ width: "auto" }}
                        >
                          Impersonate
                        </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {myTeamsList?.map((item, index) => {
                      return (
                        <tr className="addBGcustomw">
                          <td
                            className="name-link cursor-pointer"
                            onClick={() => {
                              navigate(
                                "/profile/edit?section=edit&user_id=" +
                                  item.id +
                                  "&tab=1"
                              );
                            }}
                          >
                            {item.first_name + " " + item.last_name}
                          </td>
                          <td className="itmeeeamil">{item.email}</td>
                          <td className="otemrole">{item.Role}</td>
                          <td className="officename">{item.office_name}</td>
                          {/* <td className="text-center cursor-pointer"  onClick={()=>callImpersonateAPI(item)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(45,45,45,1)"><path d="M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.6888 14.8776 14.8818 12.2168 14.9954L11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.31125 9.1222 2.11818 11.783 2.00462L11.9999 2ZM11.9999 4C10.4022 4 9.09623 5.24892 9.00499 6.82373L8.9999 7V10C8.9999 11.6569 10.343 13 11.9999 13C13.5976 13 14.9036 11.7511 14.9948 10.1763L14.9999 10V7C14.9999 5.34315 13.6567 4 11.9999 4Z"></path></svg></td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="not-found cart-notfound">
                  <div className="interboxes">
                    <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                    <p>{t("Presently there are no team members.")}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const handleDelete = (id) => {
    setSelectedTeamId(id);
    setShowModalMsgDelete("Are you sure you want to delete the team?");
    setConfirmDelete(true);
  };

  const renderMyTeamsTableReport = () => {
    return (
      <>
        <div className="row my-team-table">
          <div className="col-lg-12 col-md-12">
            <div className="course-info-table">
              {teamsList.length > 0 ? (
                <table className="table mb-0 office_list table-striped">
                  <thead>
                    <tr>
                      <th
                        className={`cursor-pointer`}
                        style={{ minWidth: "300px" }}
                      >
                        {t("Team Name")}
                      </th>
                      <th
                        className={`cursor-pointer`}
                        style={{ minWidth: "300px" }}
                      >
                        {t("Created On")}
                      </th>
                      <th
                        className={`cursor-pointer`}
                        style={{ minWidth: "300px" }}
                      >
                        {t("Actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {teamsList?.map((item, index) => {
                      return (
                        <tr className="addBGcustomw">
                          <td className="itmeeeamil">{item?.team_name}</td>
                          <td className="itmeeeamil">
                            {moment(item?.created_dt).format("DD MMM, YYYY")}
                          </td>
                          <td className="itmeeeamil d-flex justify-content-center align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="red"
                              className="me-2 cursor-pointer"
                              onClick={() => handleDelete(item?.id)}
                            >
                              <path d="M3 6h18v2H3V6zm3 3h12l-1.5 12h-9L6 9zm4 2v8h2v-8h-2zm4 0v8h2v-8h-2zM8 4V3h8v1h5v2H3V4h5z" />
                            </svg>
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                handleViewTeamMembersClick(item?.users_data)
                              }
                            >
                              {t("View Team Members")}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="not-found cart-notfound">
                  <div className="interboxes">
                    <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                    <p>{t("Presently there are no teams.")}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderContent = () => {
    return (
      <section className="my-credit-points learningpaths">
        <div className="container">
          <div className="row ">
            <div className="col-md-12">
              {false && (
                <div className="search_heading d-flex align-items-center justify-content-between gap-2">
                  <p className="lable-heading_search">{t("My Team List")}</p>
                </div>
              )}
              <div className="d-flex justify-content-end">
                <div className="confirm-row m-0">
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="form-control"
                    autocomplete="off"
                    value={searchValue}
                    onChange={(evt) => {
                      setSearchValue(evt.target.value);
                    }}
                  />
                  <button className="confirm-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                        fill="black"
                      ></path>
                    </svg>
                    {t("Search")}
                  </button>
                </div>
              </div>
            </div>

            <div className=" my_learningpath_tab mt-1">
              {renderTableReport()}
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderMyTeamsContent = () => {
    return (
      <div className="container mt-5">
        <div className="row ">
          <div className="col-md-12">
            <div className="d-flex align-items-center justify-content-between">
              <div className="confirm-row m-0">
                <input
                  type="search"
                  id="search"
                  name="search"
                  className="form-control"
                  autocomplete="off"
                  value={searchValue}
                  onChange={(evt) => {
                    setSearchValue(evt.target.value);
                  }}
                />
                <button className="confirm-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                      fill="black"
                    ></path>
                  </svg>
                  {t("Search")}
                </button>
              </div>
              <button
                className="btn btn-primary"
                onClick={() => {
                  dispatch(setCurrentView(10));
                  setShow(true);
                }}
              >
                {t("Create Team")}
              </button>
            </div>
          </div>

          <div className=" my_learningpath_tab mt-1">
            {renderMyTeamsTableReport()}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Loader start={isLoading} />
      {isMobile === "true" ? (
        renderContent()
      ) : (
        <Page>
          {/* {renderContent()} */}
          <div className="container">
            <div className="row mt-5">
              <div className="col-12">
                <div className="contsection">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => {
                      setKey(k);
                      if (k == "myTeamsList") {
                        getMyTeamsList();
                      } else if (k === "myTeams") {
                        getDefaultTeams();
                      }
                    }}
                  >
                    <Tab eventKey={"myTeamsList"} title={t("My Team Members")}>
                      {renderContent()}
                    </Tab>
                    {authBroker?.payload?.user?.role?.includes(
                      "program_manager"
                    ) && (
                      <Tab eventKey={"myTeams"} title={t("My Teams")}>
                        <div className="mt-5">
                          <div className="row coach-list g-xxl-5 g-4">
                            {renderMyTeamsContent()}
                          </div>
                        </div>
                      </Tab>
                    )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={show}
            onHide={() => setShow(false)}
            size="md"
            dialogClassName="modal-90w modalassign modal-dialog-scrollable"
            aria-labelledby="example-custom-modal-styling-title"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                {titleHeading}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {currentView === 5 && (
                <CreateteamOptions
                  parentId={""}
                  parentName={""}
                  selectedOfficeList={selectedOfficeList}
                  selectedCompletedCourseList={selectedCompletedCourseList}
                  setFilteredFromCoursesOffices={setFilteredFromCoursesOffices}
                  setFilterReq={setFilterReq}
                  setTitleHeading={setTitleHeading}
                  setIsByNameTeam={setIsByNameTeam}
                  fromMyTeams={true}
                />
              )}
              {currentView === 10 && (
                <ChooseTeammateForTeam
                  parentId={""}
                  parentName={""}
                  selectedTeamMatesList={selectedTeamMatesListForTeam}
                  setSelectedTeamMatesList={setSelectedTeamMatesListForTeam}
                  setTitleHeading={setTitleHeading}
                  setFilteredFromCoursesOffices={setFilteredFromCoursesOffices}
                  setIsByNameTeam={setIsByNameTeam}
                  fromMyTeams={true}
                />
              )}
              {currentView === 7 && (
                <ChoosePeople
                  parentId={""}
                  parentName={""}
                  selectedOfficeList={selectedOfficeList}
                  setSelectedOfficeList={setSelectedOfficeList}
                  setTitleHeading={setTitleHeading}
                  fromMyTeams={true}
                />
              )}
              {currentView === 8 && (
                <ChooseFromCompletedCourse
                  parentId={""}
                  parentName={""}
                  selectedCompletedCourseList={selectedCompletedCourseList}
                  setSelectedCompletedCourseList={
                    setSelectedCompletedCourseList
                  }
                  setTitleHeading={setTitleHeading}
                />
              )}
              {currentView === 4 && (
                <CreateTeam
                  parentId={""}
                  parentName={""}
                  filteredFromCoursesOffices={filteredFromCoursesOffices}
                  setFilteredFromCoursesOffices={setFilteredFromCoursesOffices}
                  filterReq={filterReq}
                  setTitleHeading={setTitleHeading}
                  setSelectedTeamsList={setSelectedTeamsList}
                  isByNameTeam={isByNameTeam}
                  setShow={setShow}
                  fromMyTeams={true}
                  setAPICall={setAPICall}
                />
              )}
            </Modal.Body>
          </Modal>

          <ConfirmModal
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={showModalMsg}
            isConfirm={true}
            isRightIcon={true}
            isConfirmwithNo={true}
            confirmAction={() => getDefaultTeams()}
          />

          <ConfirmModal
            confirmModal={confirmDelete}
            setConfirmModal={setConfirmDelete}
            showModalMsg={showModalMsgDelete}
            isConfirm={isConfirm}
            confirmId={""}
            confirmAction={() => callDeleteTeamAPI(selectedTeamId)}
            isRightIcon={true}
            noAction={() => {}}
          />

          <TeamMembersModal
            show={showModal}
            onClose={() => setShowModal(false)}
            setShowModal={setShowModal}
            membersList={selectedTeamMembers}
            selectedTrainerId={""}
            setSelectedTrainerId={""}
            setTrainersList={[]}
          />
        </Page>
      )}
    </>
  );
};
export default MyTeamListPage;
